module.exports = __webpack_public_path__ + "img/5.8f5ae656.png";